if (!customElements.get('ugc-gallery')) {
  customElements.define(
    'ugc-gallery',
    class UgcGallery extends HTMLElement {
      constructor() {
        super();

        this.swiper = null;
        this.slideGap = 8;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        this.handleResize = this.handleResize.bind(this);
        this.handleQueryChange = this.handleQueryChange.bind(this);
      }

      connectedCallback() {
        this.swiperElement = this.querySelector('.ugc-gallery__swiper');
        this.offsetSource = document.getElementById(this.dataset.offsetSourceId);
        this.slides = Array.from(this.querySelectorAll('.ugc-gallery__item'));

        if (!this.swiperElement || this.slides.length === 0) return;

        if (this.mobileQuery.matches) {
          this.initSwiper();
        }

        this.mobileQuery.addEventListener('change', this.handleQueryChange);
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        this.mobileQuery.removeEventListener('change', this.handleQueryChange);
        window.removeEventListener('resize', this.handleResize);
        this.destroySwiper();
      }

      handleQueryChange() {
        if (this.mobileQuery.matches) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }

      handleResize() {
        if (!this.mobileQuery.matches) return;
        this.updateOffset();
      }

      initSwiper() {
        if (this.swiper || typeof Swiper === 'undefined' || this.slides.length <= 1) return;

        const offset = this.getOffsetLeft();

        this.swiper = new Swiper(this.swiperElement, {
          speed: 500,
          grabCursor: true,
          spaceBetween: this.slideGap,
          slidesPerView: 1.15,
          spaceBetween: 8,
          watchSlidesProgress: true,
          slidesOffsetBefore: offset,
          slidesOffsetAfter: offset,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 0.7,
            thresholdDelta: 10,
            thresholdTime: 120,
          },
          a11y: {
            enabled: true,
          },
          on: {
            resize: () => {
              this.updateOffset();
            },
          },
        });

        requestAnimationFrame(() => {
          this.updateOffset();
        });
      }

      destroySwiper() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      getOffsetLeft() {
        if (!this.offsetSource) return 0;

        const rectLeft = this.offsetSource.getBoundingClientRect().left;
        const sourceStyles = window.getComputedStyle(this.offsetSource);
        const paddingLeft = parseFloat(sourceStyles.paddingLeft) || 0;

        return Math.max(0, Math.round(Math.max(rectLeft, paddingLeft)));
      }

      updateOffset() {
        if (!this.swiper) return;

  
        const offset = this.getOffsetLeft();
        this.swiper.params.slidesOffsetBefore = offset;
        this.swiper.params.slidesOffsetAfter = offset;
        this.swiper.update();
      }


    }
  );
}
